/**
 * Generate a function enforcing a structure from rawData
 */
const undesirableValues = { undefined: true, null: true };

export default function (structure) {
  const FIELDS = Object.entries(structure);
  return function enforceStructure(rawData) {
    const structuredData = {};
    FIELDS.forEach(
      ([name, get]) => {
        const value = get(rawData);

        if (undesirableValues[value]) {
          return;
        }

        structuredData[name] = get(rawData);
      });
    return structuredData;
  };
}



// WEBPACK FOOTER //
// ./~/virgo/src/structures/enforce.js